import * as React from "react";
const SvgSucess = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "#00B600", style: {
  fill: "#00B600",
  fill: "color(display-p3 0.0000 0.7137 0.0000)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M7 11.8008L11.5 15.8008L18 9.30078", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgSucess;
